// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3eCVx","right":"styles_right__20Uh_"};